import { Injectable } from '@angular/core';
import { LookbookApiService } from '@epicuro-next/data/engagement/engagement-api';
import { LookBook } from '@epicuro-next/models/engagement';
import {
  selectAccountId,
  selectSiteId,
} from '@epicuro-next/state/session-state';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concatLatestFrom } from '@ngrx/operators';
import { select, Store } from '@ngrx/store';
import { catchError, filter, map, switchMap, take } from 'rxjs/operators';

import {
  loadLookBooks,
  loadLookBooksError,
  loadLookBooksSuccess,
} from './shop-the-looks-actions';
import {
  selectFullLoaded,
  selectLookBooksLoading,
  selectShopTheLooksParams,
} from './shop-the-looks-selectors';

@Injectable()
export class ShopTheLooksEffects {
  constructor(
    private actions$: Actions,
    private lookbookApi: LookbookApiService,
    private store: Store,
  ) {}

  public loadLookBooks$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadLookBooks),
      concatLatestFrom(() => [
        this.store.pipe(select(selectShopTheLooksParams)),
        this.store.pipe(select(selectLookBooksLoading)),
        this.store.pipe(select(selectFullLoaded)),
        this.store.pipe(select(selectAccountId), filter<string>(Boolean)),
        this.store.select(selectSiteId),
      ]),
      map(([, params, isLoading, isFullLoaded, accountId, siteId]) => ({
        params,
        isLoading,
        isFullLoaded,
        accountId,
        siteId,
      })),
      filter(({ isLoading, isFullLoaded }) => !isLoading || !isFullLoaded),
      switchMap(({ params: queryparams, accountId, siteId }) =>
        this.lookbookApi
          .getAllLookBooks({ queryparams, accountId, siteId })
          .pipe(
            take(1),
            map((response) => {
              if (response) {
                const { items, total } = response;
                return loadLookBooksSuccess({
                  lookBooks: items as unknown as LookBook[],
                  total,
                });
              } else {
                return loadLookBooksError({
                  error: 'Not found',
                });
              }
            }),
            catchError((err) => [
              loadLookBooksError({
                error: err.message,
              }),
            ]),
          ),
      ),
    ),
  );
}
